export default "a6b38b6c0da8cc69.svg"